import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5213f593"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setting-information-edit" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "お知らせ編集", -1))

import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import InformationForm from '@/components/settings/information/InformationForm.vue'
import NewsRepository from '@/repositories/news-repository'
import repositoryFactory from '@/factories/repository-factory'
import NewsItem from '@/models/NewsItem'
import { useInitDataStore } from '@/stores/initDataStore'
import { useNewsHistoryStore } from '@/stores/newsStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const newsItem = ref<NewsItem>()
const initDataStore = useInitDataStore()
const newsStore = useNewsHistoryStore()
const router = useRouter()
const route = useRoute()

onMounted(async () => {
  const id = route.params.id

  if (route.params.id) {
    if (Object.keys(newsStore.newsHistory).length === 0) {
      router.replace('/settings/information')

      return
    }

    newsItem.value = newsStore.newsHistory.findById(Number(id))
  } else {
    newsItem.value = new NewsItem({})
  }
})

const submit = async () => {
  if (!confirm('登録します。よろしいですか？')) {
    return
  }

  const repository = (await repositoryFactory.create()).get('news') as NewsRepository
  const notificationId = initDataStore.initData.systemInfo.notification.id
  const item = newsItem.value

  if (item === undefined) {
    return
  }

  if (!notificationId) {
    return
  }

  await repository.createOrUpdate(notificationId, item)

  alert('登録しました。')

  router.push('/settings/information')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (newsItem.value)
      ? (_openBlock(), _createBlock(InformationForm, {
          key: 0,
          modelValue: newsItem.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newsItem).value = $event)),
          onSubmit: submit
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})